<template>
  <span class="rai-wigo box">
    <wigo-chip
      v-for="(wigo, index) in wigos"
      :key="`wigo-${index}`"
      :wigo="wigo"
      :outlined="wigoSelected !== wigo"
      link
      @click="selectWigo(wigo)"
      class="mr-2"
      :show-details="showDetails"
    />
  </span>
</template>

<script>
import WigoChip from '@/components/global/WigoChip.vue'

export default {
  name: "WigoChooser",

  components: { WigoChip },

  props: {
    wigos: {
      type: Array,
      required: true
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    wigoSelected: {
      type: Array,
      required: false,
    }
  },

  data() {
    return {
      // wigoSelected: undefined
    }
  },

  methods: {
    selectWigo(wigo) {
      this.$emit('wigoSelected', wigo)
    }
  },

  created() {
  }
};
</script>
<style scoped>
</style>